<template>
  <article class="search-result-blog flex-col md:flex-row">
    <figure class="responsive-image rounded-sm no-overflow bg-gray-200">
      <img :src="item.content_media_image" alt="" />
    </figure>
    <div>
      <span class="text-sm c-gray-600 inline-block mt-md md:mt-0">
        {{ date }}
      </span>
      <h3 class="my-sm text-base">
        <a
          :href="item.url"
          @click="sendEvent('click', item, 'Global Search Blog Result Clicked')"
          class="c-black hover:c-blue-400"
        >
          <ais-highlight :hit="item" attribute="content_title" />
        </a>
      </h3>
      <hit-description :item="item" :limit="90" />
    </div>
  </article>
</template>

<script>
import formatDate from '../../../lib/filters/formatDate';
import HitDescription from './HitDescription.vue';

export default {
  components: {
    'hit-description': HitDescription
  },
  props: ['item', 'sendEvent'],
  computed: {
    date() {
      return formatDate(this.item.content_created);
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';
@import '../../../scss/mixins';

.search-result-blog {
  @media (min-width: 1024px) {
    figure {
      width: 33%;
      max-width: 190px;
      max-height: 115px;
      margin-right: 1.25em;
      flex-shrink: 0;
    }
  }
}
</style>
